<template>
  <div class="navbar clearfix">
    <el-breadcrumb class="breadcrumb-container" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="item in levelList"
        :key="item.name"
        :to="item.meta.redirect"
      >{{item.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
 
<script>
/**
 * 面包屑导航组件
 * 功能：根据 $route.matched 生成层级，首页置顶
 */
export default {
  name: "Navbar",
  data() {
    return {
      levelList: []
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      //$route.matched一个数组 包含当前路由的所有嵌套路径片段的路由记录
      let matched = this.$route.matched.filter(item => item.name);
      const first = matched[0];      
      if (
        first &&
        first.name.trim().toLocaleLowerCase() !==
          "homePage".toLocaleLowerCase()
      ) {
        matched = [{ path: "/homePage", meta: { title: "首页" ,redirect:"/homePage"} }].concat(
          matched
        );
      }else{
        matched=[]
      }
      this.levelList = matched;
    }
  }
};
</script>